import { ColumnsType } from "antd/lib/table";
import moment from "moment-timezone";
import { Button, Card, Input, Table } from "antd";

import { TableHelper } from "../../../util/TableHelper";
import Loading from "../../common/Loading";
import AdvanceBookingDetailsModal from "../AdvanceBookingRequestReport/AdvanceBookingRequestDetailsModal";
import { useABRPenaltyCollectionReport } from "./index.hook";
import styles from "../AdvanceBookingRequestReport/index.module.less";
import MultiFunctionDateFilter from "../../common/MultiFunctionDateFilter";

import type { FormattedAdvanceBookingPenaltyRecord } from "../../../shared/interface/ABRReport.interface";

const ABRPenaltyCollectionReport = () => {
  const config = useABRPenaltyCollectionReport();

  const formatTime = (time: string | null) => (time ? moment(time).format("HH:mm") : "");
  const renderTime = (key: keyof FormattedAdvanceBookingPenaltyRecord) => (text: any) => <div>{formatTime(text)}</div>;
  const valueSorter = (key: keyof FormattedAdvanceBookingPenaltyRecord) => ({ compare: TableHelper.valueCompare(key) });

  const columns: ColumnsType<FormattedAdvanceBookingPenaltyRecord> = [
    {
      align: "right",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: TableHelper.renderNumberValue,
      sorter: valueSorter("sr_no")
    },
    {
      align: "left",
      title: "Booking ID",
      dataIndex: "booking_id",
      key: "booking_id",
      render: (text, record) => (
        <div onClick={() => config.handleModalOpen(record?.id)} className={`gx-link ${record.id === config.selectedRecordId ? styles["modal__description"] : ""}`}>
          {TableHelper.getValue(text)}
        </div>
      ),
      sorter: valueSorter("booking_id")
    },
    {
      align: "left",
      title: "Username",
      dataIndex: "full_name",
      key: "full_name",
      render: TableHelper.renderText,
      sorter: valueSorter("full_name")
    },
    {
      align: "left",
      title: "Vehicle Type",
      dataIndex: "vehicle_type_name",
      key: "vehicle_type_name",
      render: TableHelper.renderText,
      sorter: valueSorter("vehicle_type_name")
    },
    {
      align: "left",
      title: "Valet Parking",
      dataIndex: "is_valet_parking",
      key: "is_valet_parking",
      render: (text) => <div>{text ? "Yes" : "No"}</div>,
      sorter: valueSorter("is_valet_parking")
    },
    {
      title: "Booking Time",
      children: [
        {
          align: "right",
          title: "In-Time",
          dataIndex: "parking_start_date",
          key: "parking_start_date",
          render: renderTime("parking_start_date"),
          sorter: { compare: TableHelper.dateSorter("parking_start_date") }
        },
        {
          align: "right",
          title: "Out-Time",
          dataIndex: "parking_end_date",
          key: "parking_end_date",
          render: renderTime("parking_end_date"),
          sorter: { compare: TableHelper.dateSorter("parking_end_date") }
        }
      ]
    },
    {
      align: "right",
      title: "Penalty Amount",
      dataIndex: "penalty_amount",
      key: "penalty_amount",
      render: (text) => <div>{text} ₹</div>,
      sorter: valueSorter("penalty_amount")
    }
  ];

  return (
    <>
      <Card
        className="gx-card card--height"
        title={
          <>
            <div className={styles["head-container"]}>
              <div className={styles["abr-penalty-report-left-section"]}>
                <div className="card-title-style gx-mr-3">ABR Penalty Collection Report</div>
                <Button onClick={config.handleRefreshList} className={`button-gradiant gx-mb-0 add-button`} loading={config.loading}>
                  Refresh
                </Button>
              </div>

              <div className={styles["abr-penalty-report-right-section"]}>
                <div className={styles["multi-filter"]}>
                  <MultiFunctionDateFilter setFromDate={config.setStartDate} setToDate={config.setEndDate} />
                  <Button type="primary" disabled={!config.setStartDate || !config.endDate} className="gx-mb-0 gx-ml-2 gx-mr-0" onClick={config.handleGo}>
                    Go
                  </Button>
                </div>
                <Input.Search className="gx-mb-0 search-component__width" allowClear placeholder="Search..." value={config.searchedText} onChange={(e) => config.handleChangeOnSearch(e.target.value)} onSearch={config.handleChangeSearch} />
              </div>
            </div>
            <div className={styles["show-penalty-amount"]}>
              <span>
                From Date: &nbsp;<strong>{config?.startDate ?? ""}</strong>
              </span>
              <span>
                To Date: &nbsp;<strong>{config?.endDate ?? ""}</strong>
              </span>
              <div>
                Total Penalty Amount: <span className="card-title-style">{config.totalPenaltyAmount ?? 0}</span> ₹
              </div>
            </div>
          </>
        }
      >
        {config.loading ? <Loading /> : <Table className="gx-table-responsive" size="small" columns={columns} dataSource={config.abrList ?? []} pagination={config.pagination} bordered onChange={config.handleChangePagination} rowKey={(record) => record.id} />}
      </Card>

      <AdvanceBookingDetailsModal handleOnClose={config.handleOnClose} isModalVisible={config.isModalVisible} abrRecordId={config.selectedRecordId} />
    </>
  );
};

export default ABRPenaltyCollectionReport;
